// extracted by mini-css-extract-plugin
export default {"assetOverview":"deleteSubCategory_assetOverview__szRy0","count":"deleteSubCategory_count__Tp2bA"};